/**
 * `POST /payment/paystack/verify-and-log-payment` answers HTTP 200 for outcomes
 * that are not a confirmed payment -- `verification_failed`,
 * `payment_entry_not_found`, `payment_method_not_found` -- so a 2xx alone
 * proves nothing. Only these two mean the payment is logged against the entry.
 */
export function isPaymentConfirmed(response: unknown): boolean {
  const status = (response as { status?: unknown } | null | undefined)?.status;
  if (typeof status !== 'string') return false;
  return status === 'already_processed' || status.startsWith('Payment successfully logged');
}

/** The API replied, but did not confirm the payment. */
export class PaymentNotConfirmedError extends Error {
  constructor(readonly response: unknown) {
    super('Payment could not be confirmed.');
    this.name = 'PaymentNotConfirmedError';
  }
}
